import { render, staticRenderFns } from "./CardListView.vue?vue&type=template&id=53be74ea&scoped=true&"
import script from "./CardListView.vue?vue&type=script&lang=ts&"
export * from "./CardListView.vue?vue&type=script&lang=ts&"
import style0 from "./CardListView.vue?vue&type=style&index=0&id=53be74ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53be74ea",
  null
  
)

export default component.exports